"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withoutReplyFormStyle = exports.replyFormStyle = void 0;

var _theme = require("./theme");

var replyFormStyle = {
  control: {
    backgroundColor: '#fff'
  },
  highlighter: {
    overflow: 'hidden'
  },
  '&multiLine': {
    highlighter: {
      padding: 9
    },
    input: {
      minHeight: 38,
      fontFamily: '"Gotham A", "Gotham B", "Helvetica Neue", Helvetica, Arial, sans-serif',
      fontSize: '14px',
      appearance: 'none',
      borderRadius: '3px',
      border: "1px solid ".concat(_theme.colors.blue.secondaryDark),
      boxShadow: 'none',
      margin: 0,
      outline: 'none',
      padding: '7px 8px',
      transition: 'all .3s ease',
      width: '100%',
      maxWidth: '100%',
      display: 'block',
      boxSizing: 'border-box',
      lineHeight: 'inherit'
    },
    suggestions: {
      list: {
        backgroundColor: 'white',
        border: '1px solid rgba(0,0,0,0.15)',
        fontSize: 14
      },
      item: {
        padding: '5px 15px',
        borderBottom: '1px solid rgba(0,0,0,0.15)',
        '&focused': {
          backgroundColor: 'rgb(207, 245, 253)'
        }
      }
    }
  }
};
exports.replyFormStyle = replyFormStyle;
var withoutReplyFormStyle = {
  control: {
    backgroundColor: '#fff'
  },
  highlighter: {
    overflow: 'hidden'
  },
  '&multiLine': {
    input: {
      minHeight: "60px",
      padding: '7px 8px'
    }
  },
  suggestions: {
    list: {
      backgroundColor: 'white',
      border: '1px solid rgba(0,0,0,0.15)',
      fontSize: 14
    },
    item: {
      padding: '5px 15px',
      borderBottom: '1px solid rgba(0,0,0,0.15)',
      '&focused': {
        backgroundColor: 'rgb(207, 245, 253)'
      }
    }
  }
};
exports.withoutReplyFormStyle = withoutReplyFormStyle;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/styles/mentionInputStyle.js
// module id = 358
// module chunks = 0 15 16 17 18